import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAdminReportList } from '../reports/services/ReportsHooks'

const AdminLayout = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { reports } = useAdminReportList()

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('adminPage.title')}
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {t('adminPage.PowerBIReports')}
          </Typography>

          {reports && reports.length > 0 ? (
            <Grid container spacing={2}>
              {reports.map((report) => (
                <Grid
                  key={report.id}
                  size={{
                    xs: 12,
                    md: 4,
                  }}
                >
                  <Card
                    sx={{
                      p: 2,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'action.hover',
                      },
                    }}
                    onClick={() => navigate(`/adminReports/${report.workspaceId}/${report.id}`)}
                  >
                    <Typography variant="subtitle1">{report.name}</Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No admin reports available</Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default AdminLayout
